import { theme } from '../../theme';

export const ROSTER = {
  ink: '#08081B',
  muted: '#63637D',
  link: theme.palette.primary.main,
  linkDisabled: theme.palette.text.disabled,
  surface: '#F6F6F8',
  cardBg: '#FFFFFF',
  border: 'rgba(8, 8, 27, 0.15)',
  hairline: 'rgba(8, 8, 27, 0.10)',
  hoverBg: 'rgba(42, 42, 139, 0.08)',
  cardShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  font: '"Nunito Sans", "Helvetica", "Arial", sans-serif',
  columns: { school: 168, teacher: 184, grade: 80, elStatus: 136, cohorts: 168, evidence: 136 },
  chip: {
    active: { bg: '#E3F4DF', fg: '#132B0D', label: 'Active EL' },
    monitoring: { bg: '#EBEBEF', fg: '#4A4A5F', label: 'Monitoring' },
    former: { bg: '#DEF0FC', fg: '#072254', label: 'Former EL' },
    waived: { bg: '#EBEBEF', fg: '#4A4A5F', label: 'Services waived' },
    departed: { bg: '#EBEBEF', fg: '#4A4A5F', label: 'Departed' },
    ltel: { bg: '#FEEAD7', fg: '#512100', label: 'LTEL' },
    newcomer: { bg: '#F4E5F7', fg: '#5A1F70', label: 'Newcomer' },
    dually_identified: { bg: '#EBEBED', fg: '#08081B', label: 'Dually identified' },
  },
} as const;
